'use client';

import { useCallback, useMemo, useState } from 'react';

import { MetricSortColumn, MetricSortState } from '~/types';

export function useMetricSort() {
  const [sort, setSort] = useState<MetricSortState>(null);

  const getSortOrder = useCallback(
    (column: MetricSortColumn): 'asc' | 'desc' | false =>
      sort?.column === column ? sort.dir : false,
    [sort]
  );

  const toggleSort = useCallback((column: MetricSortColumn) => {
    setSort(prev => {
      if (prev?.column !== column) return { column, dir: 'asc' };
      if (prev.dir === 'asc') return { column, dir: 'desc' };
      return null;
    });
  }, []);

  const orderParams = useMemo(
    () => ({
      OrderImpressions: sort?.column === 'impressions' ? sort.dir : undefined,
      OrderClicks: sort?.column === 'clicks' ? sort.dir : undefined,
      OrderCtr: sort?.column === 'ctr' ? sort.dir : undefined,
      OrderGmv: sort?.column === 'gmv' ? sort.dir : undefined,
    }),
    [sort]
  );

  return { sort, getSortOrder, toggleSort, orderParams };
}
